import { render, staticRenderFns } from "./productOrder.vue?vue&type=template&id=15132bd5&scoped=true&"
import script from "./productOrder.vue?vue&type=script&lang=js&"
export * from "./productOrder.vue?vue&type=script&lang=js&"
import style0 from "./productOrder.vue?vue&type=style&index=0&id=15132bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15132bd5",
  null
  
)

component.options.__file = "productOrder.vue"
export default component.exports